import React, { useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import ProductCard from "../components/ProductCard";
import { MaskedLines } from "../components/Reveal";
import SEO from "../components/SEO";

export default function Catalog() {
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState("Tous");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data.filter((p) => p.customizable))).finally(() => setLoading(false));
  }, []);

  const categories = useMemo(() => {
    return ["Tous", ...Array.from(new Set(products.map((p) => p.category)))];
  }, [products]);

  const visible = filter === "Tous" ? products : products.filter((p) => p.category === filter);

  return (
    <div className="mx-auto max-w-[1400px] px-5 pt-20 pb-28 md:px-10">
      <SEO title="Catalogue — objets à personnaliser" path="/catalogue"
        description="Mugs, gourdes, sacs, bois et métal : choisissez un objet et personnalisez-le avec votre texte, votre photo, vos couleurs. Fait main en Suisse." />
      <header className="border-b border-line pb-10">
        <p className="mb-4 text-xs uppercase tracking-[0.3em] text-terra">Le catalogue</p>
        <h1 className="font-serif text-5xl font-light leading-[0.95] tracking-tight text-ink md:text-8xl">
          <MaskedLines lines={["Choisissez.", "Personnalisez."]} />
        </h1>
        <p className="mt-6 max-w-lg text-ink2">
          Chaque concept peut être porté par vos mots, vos images, vos couleurs. Cliquez sur un produit pour ouvrir l'atelier de personnalisation.
        </p>
      </header>

      <div className="sticky top-[73px] z-30 -mx-5 mt-8 flex gap-2 overflow-x-auto bg-cream/80 px-5 py-4 backdrop-blur-xl md:mx-0 md:px-0">
        {categories.map((c) => (
          <button
            key={c}
            data-testid={`filter-${c.toLowerCase()}`}
            onClick={() => setFilter(c)}
            className={`shrink-0 border px-5 py-2 text-xs uppercase tracking-widest transition-colors ${
              filter === c ? "border-ink bg-ink text-cream" : "border-line text-ink2 hover:bg-sand"
            }`}
          >
            {c}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="grid grid-cols-1 gap-8 pt-10 sm:grid-cols-2 lg:grid-cols-4">
          {[0, 1, 2, 3].map((i) => (
            <div key={i} className="aspect-[4/5] animate-pulse bg-sand" />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-8 pt-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6" data-testid="catalog-grid">
          {visible.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
